export default function(){
(function($) {
    // $(document).ready(function() {
    //     $('.creepy_image--modal .creepyImage ').on('click', function (event) {
    //         console.log("test");
    //         if (!$(this).parent('div').siblings("div.modalContainer").is($("div.modalContainer--show")[0])) {
    //             $(this).parent('div').siblings("div.modalContainer").toggleClass("modalContainer--show");
    //         } else {
    //             $(this).parent('div').siblings("div.modalContainer").toggleClass("modalContainer--show");
    //         }
    //
    //     });
    // });
    // $(document).ready(function(){
    //     $('a.creepyButton__modal').removeAttr("href");
    //     $('a.creepyButton__modal').on('click', function(event){
    //         if(!$(this).closest('div').find("div.modalContainer").is($("div.modalContainer--show")[0])) {
    //             $("div.modalContainer--show:first").removeClass("modalContainer--show");
    //             $(this).closest('div').find("div.modalContainer").toggleClass("modalContainer--show");
    //         }
    //         else {
    //             $(this).closest('div').find("div.modalContainer").toggleClass("modalContainer--show");
    //         }
    //     });
    //     $(document).click(function(event) {
    //         //if you click on anything except the modal itself or the "open modal" link, close the modal
    //         if (!$(event.target).closest(".modalContent,.creepyButton__modal,.creepyImage").length) {
    //             $("body").find(".modalContainer").removeClass("modalContainer--show");
    //             $("body").css({"overflow-y" : "auto"});
    //             $(".response-box-rychla-poptavka").hide();
    //             $(".creepy__paragraph").show();
    //         }
    //     });
    //
    //     $(".modalContent--close").click(function (event) {
    //         $("body").find(".modalContainer").removeClass("modalContainer--show");
    //         $("body").css({"overflow-y" : "auto"});
    //         $(".response-box-rychla-poptavka").hide();
    //         $(".creepy__paragraph").show();
    //     });
    // });
})(jQuery);
}